import { Temporal, Instant } from "js-joda";

import { IValidatable } from "infrastructure/validation";
import { ITenant, IEnterprise, ISecurityRole, IAccount } from "ui/screens/security/models";
import { IPickerState } from "ui/screens/security/shared/picker/Picker.types";

export const accountPickerName = "grant-role-form-account-picker";
export const tenantPickerName = "grant-role-form-tenant-picker";
export const validDateFromPickerName = "grant-role-form-valid-date-from-picker";
export const validDateToPickerName = "grant-role-form-valid-date-to-picker";
export const enterpriseWideFieldName = "enterprise-wide-field";

export interface IGrantRoleFormState {
  enterprise?: IEnterprise;
  securityRole?: ISecurityRole;
  [tenantPickerName]: IValidatable<IPickerState<ITenant>>;
  [accountPickerName]: IValidatable<IPickerState<IAccount>>;
  [validDateFromPickerName]: IValidatable<Temporal | undefined>;
  [validDateToPickerName]: IValidatable<Temporal | undefined>;
  [enterpriseWideFieldName]: IValidatable<boolean | undefined>;
}

export interface IGrantRoleData {
  tenant: ITenant;
  account: IAccount;
  securityRole: ISecurityRole;
  validDateFrom?: Instant;
  validDateTo?: Instant;
  enterpriseWide?: boolean;
}
